import BaseListStyle from "../../styles/BaseListStyle"; 

const BookingQueueStyles = (theme) => {
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    checkbox: {
      minWidth: 130,
      margin: "0px 5px"
    },
    dialogPaper: {
      style: {
        backgroundColor: "#f9f9f9",
        boxShadow: "none"
      },
    },
    bookingQueueList: {
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
    },
    bookingQueueListEdit: {
      "& .MuiToolbar-root": {
        marginRight: 20,
      },
      "& .MuiTableHead-root": {
        display: "block",
        tableLayout: "fixed",
        width: "calc(100% - 20px)"
      },
      "& .MuiTableHead-root tr th:first-of-type": {
        maxWidth: 28,
        overflow: "hidden"
      },
      "& .MuiTableHead-root tr th:first-of-type span.MuiCheckbox-root span.MuiIconButton-label": {
        marginLeft: -4
      },
    },
    bookingQueueForm: {
      "& .MuiInputBase-input": {
        fontSize: 11
      }
    },
    bookingQueueFormDimensionsCell: {
      fontSize: 12,
      paddingLeft: "3px !important",
      paddingRight: "3px !important",
    },
    bookingQueueFormDimensionsHeader: {
      fontSize: 12,
      paddingLeft: "4px !important",
      paddingRight: "4px !important",
    },
  }
}

export default BookingQueueStyles;
